var _circle, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1393,
    cx: 13.2549,
    cy: 13.8,
    r: 13,
    fill: "#444851"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.2549,
    cy: 13.8,
    r: 13,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7492 9.33507C16.7492 7.49844 15.3141 6.00586 13.5483 6.00586C11.7825 6.00586 10.3474 7.49844 10.3474 9.33507C10.3474 11.1772 11.7824 12.6643 13.5483 12.6643C15.3141 12.6643 16.7492 11.1772 16.7492 9.33507ZM7.14648 18.1908C8.52822 20.3436 10.8755 21.7641 13.5483 21.7641C16.221 21.7641 18.5684 20.3437 19.9501 18.1908C19.9181 15.9879 15.6769 14.7728 13.5483 14.7728C11.4197 14.7728 7.17314 15.9879 7.14648 18.1908Z",
    fill: "#444851"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7bc547b899ca207be305f80aa1a64b8d.svg";
export { ForwardRef as ReactComponent };